import React, { ChangeEvent } from "react";
import { useIntl } from "react-intl";
import { getSupportedLocalesForBO } from "../../lang";
import contextStore from "../../redux/store";

const LocaleSwitch = (): JSX.Element => {
  const intl = useIntl();

  const locale = contextStore.useStoreState(state => state.settings.locale);
  const changeLocale = contextStore.useStoreActions(
    actions => actions.settings.changeLocale
  );

  const handleChangeLocale = (e: ChangeEvent<HTMLSelectElement>) => {
    changeLocale(e.target.value);
  };

  const locales = getSupportedLocalesForBO();

  return (
    <div className="flex">
      <select
        className="form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5 transition ease-in-out duration-150"
        value={locale}
        onChange={handleChangeLocale}
      >
        {locales.map(l => (
          <option key={l} value={l}>
            {intl.formatMessage({ id: `general.language.${l}` })}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LocaleSwitch;
